import { z } from 'zod';

export const eventTypesSchema = z.object({
  id: z.number(),
  title: z.string(),
  slug: z.string(),
  description: z.string().nullable(),
  lengthInMinutes: z.number().optional(),
  locations: z.array(
    z.object({
      address: z.string().optional(),
      type: z.string(),
    }),
  ),
});
export const getEventTypesReqDto = z.array(eventTypesSchema);
export const getEventTypesV2ResponseDto = z.object({
  status: z.string(),
  data: getEventTypesReqDto,
});

export type GetEventTypesReqDto = z.infer<typeof getEventTypesReqDto>;
